module.exports = __webpack_public_path__ + "img/Klaus.554206fc.png";